import { useEffect, useRef } from 'react'
import { useModalForms } from '../../../modalForms/modalFormsContext'
import { CardRule } from './cardRule'
import { CouponRulesProvider } from './couponRulesContext'
import { ContainerDoubleInput } from './containerDoubleInput'
import { GroupsOrProductsLinkToCoupons } from './GroupsOrProductsLinkToCoupons'
import { InputCheckAndLabel } from './inputCheckAndLabel'
import { ButtonNextForm } from './buttonNextForm'

import { Container } from './style'

export function CouponRules () {
    const { alertButtonToClickHim, changeVisibleContent } = useModalForms()

    const bottomRef = useRef(null)

    useEffect(() => {
        if(alertButtonToClickHim.breathButton){
            bottomRef.current.scrollIntoView({
                behavior: 'smooth'
            })
        }
    }, [alertButtonToClickHim])


    return (
            <Container changeVisibleContent={changeVisibleContent}>
               
                <h3>Regras do cupom</h3>

                <CouponRulesProvider>

                    <CardRule 
                        type={0}
                        title="Produtos"
                        explain="desconto somente no valor dos produtos"
                    />

                    <CardRule 
                        type={1}
                        title="Frete"
                        explain="desconto somente no valor do frete"
                    />

                    <CardRule 
                        type={2}
                        title="Valor Total"
                        explain="desconto no valor total da compra"
                    />


                    <ContainerDoubleInput /> 


                    <GroupsOrProductsLinkToCoupons />


                    <InputCheckAndLabel />   


                    <ButtonNextForm />

                </CouponRulesProvider>
            

                <div ref={bottomRef} />
        </Container>
    )
}
